import _ from 'underscore';
import { getProductScopeData } from '@bingads-webui-campaign-react/product-services';
import { getProductData as GetProductData } from '@bingads-webui-campaign/audience-campaign-shared';

export const getProductData = (params, serverContext) => {
  const isOdataGetProductScopeEnabled = _.get(serverContext, ['DynamicPermissions', 'OdataGetProductScope'], false);
  let p = null;

  if (!isOdataGetProductScopeEnabled) {
    p = GetProductData(params);

    return p;
  }

  const options = {
    dataName: 'MetaData',
  };

  if (params.salesCountry) {
    options.countryCode = params.salesCountry;
  }

  if (params.campaignId) {
    options.campaignId = params.campaignId;
    options.getCampaignCriterions = true;
    options.bypassCache = true;
    options.cacheResponse = false;
    options.shouldShowPlaceholderStoreIfExists = true;
  } else {
    options.bypassCache = false;
    options.cacheResponse = true;
  }

  if (params.getCampaignCriterionsOnly) {
    options.getCampaignCriterionsOnly = true;
  } else {
    options.getProductConditionOptions = true;
    options.getSalesCountryCollection = true;
    options.getDynamicDataFeedOptions = true;

    if (params.getCategoryFullData) {
      options.getCategoryFullData = true;
    }

    if (params.getProductTypeFullData) {
      options.getProductTypeFullData = true;
    }
  }

  p = getProductScopeData(null, serverContext, options);

  return p;
}
